/**
 * Vagon Pixel Stream Types.
 * Type definitions for Vagon SDK integration.
 */

import { ICrossAppMessageData } from '@newroom-connect/library/interfaces';

/**
 * Connection status for pixel stream.
 */
export type PixelStreamConnectionStatus = 'disconnected' | 'connecting' | 'connected' | 'error';

/**
 * Session information from Vagon.
 */
export interface IVagonSessionInformation {
  session?: {
    ping?: number;
    os?: string;
    device_type?: string;
  };
  machine?: {
    status?: string;
    friendly_status?: string;
    connection_status?: string;
    region?: string;
    uid?: string;
    application_id?: number;
    stream_id?: number;
    machine_id?: number;
  };
}

/**
 * Vagon SDK global interface.
 */
export interface IVagonSDK {
  // Event listeners
  onApplicationMessage(callback: (evt: { message: string }) => void): void;
  onConnected(callback: () => void): void;
  onDisconnected(callback: () => void): void;
  onFailed(callback: () => void): void;
  onSessionInformation(callback: (data: IVagonSessionInformation) => void): void;
  onInitialization(callback: () => void): void;
  onInstallationFailed(callback: () => void): void;
}

/**
 * KeyPress payload structure from Unreal Engine.
 * This represents the nested payload format sent when a key is pressed in Unreal Engine.
 */
export interface IPixelStreamApplicationEvent {
  $type: 'KeyPress';
  payload: {
    data: ICrossAppMessageData
  };
}

/**
 * Window interface extension for Vagon SDK.
 */
declare global {
  interface Window {
    Vagon?: IVagonSDK;
  }
}
